import React, { FC } from 'react';
import styles from './light_header.module.scss';
import { HeaderContent } from '../HeaderContent';
import { HeaderContentLogo } from '../HeaderContentLogo';
import { useUser } from '../../user/useUser';
import { Row, Column } from '../../components/grid/Grid';

type Props = { source: string };

export const LightHeader: FC<Props> = ({ source, children }) => {
  const { loggedIn } = useUser();
  return (
    <header id="nav" className={styles.container}>
      <HeaderContent>
        <Row>
          <Column className={styles.wrapper}>
            <HeaderContentLogo
              loggedIn={loggedIn}
              hideBaseline={false}
              source={source}
            />
            <div>{children}</div>
          </Column>
        </Row>
      </HeaderContent>
    </header>
  );
};
